import React from 'react';
import Tooltip from 'components/mui/Tooltip';

import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';

import CONST from 'domain/documents/constants';

type Props = {
  documentTags: Set<string>;
};

const PaymentInProgress: React.FC<Props> = ({ documentTags }) => {
  const isPaymentInProgress = documentTags.has(CONST.tags.paymentInProgress);
  const t = {
    id: 'tooltip.paymentInProgress',
    defaultMessage: 'Payment in progress',
  };

  return (
    isPaymentInProgress && (
      <Tooltip t={t} placement="top">
        <BorderColorOutlinedIcon sx={{ fontSize: 20, color: 'grey.600' }} />
      </Tooltip>
    )
  );
};

export default PaymentInProgress;
